// Pure builder for the native TinyMCE "Insert Field" menu items shared by
// Email.jsx and Sms.jsx. Kept free of any TinyMCE/editor APIs so it can be
// unit tested on its own: `insert(token)` performs the actual editor
// insertion for a token (e.g. "{{first_name}}") and `openDialog()` opens the
// "new recipient field" dialog.
//
// Recipient fields only make sense for a targeted audience (a general
// broadcast can go to hundreds of thousands of contacts), so
// `allowRecipientFields` gates the recipient-field items, the "+ New
// recipient field…" item, and the separators around them out of the menu
// entirely.
export const buildInsertFieldItems = ({
  t,
  recipientFields = [],
  recipientCount = 0,
  insert,
  openDialog,
  allowRecipientFields = true,
}) => [
  {
    type: 'menuitem',
    text: t('insertField.firstName'),
    onAction: () => insert('{{first_name}}'),
  },
  {
    type: 'menuitem',
    text: t('insertField.employeeId'),
    onAction: () => insert('{{employee_id}}'),
  },
  ...(allowRecipientFields
    ? [
        { type: 'separator' },
        ...recipientFields.map(field => ({
          type: 'menuitem',
          text: t('insertField.recipientFieldItem', {
            name: field.name,
            filledCount: field.filledCount,
            recipientCount,
          }),
          onAction: () => insert(field.token),
        })),
        { type: 'separator' },
        {
          type: 'menuitem',
          text: t('insertField.newRecipientField'),
          onAction: () => openDialog(),
        },
      ]
    : []),
];
